// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"a0-z","vrsnlCrossSiteLabel":"b0-z"};